import { createActions } from 'redux-actions';

import { PaymentTransaction } from '@models/PaymentTransaction';
import { Billing } from '@models/Billing';
import { CreatePaymentTransactionParams } from '@apis/PaymentTransactionApi';
import { GetBillingParams } from '@apis/BillingApi';
import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';
import { GetPersonalAccidentQuoteParams } from '@apis/PersonalAccidentQuoteApi';

export type State = {
  personalAccidentQuote?: PersonalAccidentQuote | null;
  billing?: Billing | null;
  paymentTransaction?: PaymentTransaction | null;
}

export type PersonalAccidentQuoteFetchPayload = GetPersonalAccidentQuoteParams;
export type BillingFetchPayload = GetBillingParams;
export type PaymentTransactionCreatePayload = CreatePaymentTransactionParams;
export type StateUpdatePayload = Partial<State>;

export const {
  personalAccidentQuoteFetch,
  billingFetch,
  paymentTransactionCreate,
  stateUpdate,
} = createActions(
  'PERSONAL_ACCIDENT_QUOTE_FETCH',
  'BILLING_FETCH',
  'PAYMENT_TRANSACTION_CREATE',
  'STATE_UPDATE',
  {
    prefix: 'PERSONAL_ACCIDENT_QUOTE_PAYMENT_PAGE',
  },
);
